import React, { FC } from "react"

const Copyright: FC = () => {
    return (
        <div className="zb-copyright">
            <p>
                Registered in England and Wales (Registered Number 929027),
                Registered Office: 250 Bishopsgate, London EC2M 4AA. Authorised
                by the Prudential Regulation Authority and regulated by the
                Financial Conduct Authority and the Prudential Regulation
                Authority. NatWest is entered on the{" "}
                <a
                    href="http://www.fca.org.uk/register"
                    target="_blank"
                    rel="noreferrer"
                >
                    Financial Services Register
                </a>{" "}
                and its Register number is 121878.
            </p>

            <p>
                Copyright &copy; National Westminster Bank plc{" "}
                {new Date().getFullYear()}.
            </p>
        </div>
    )
}

export default Copyright
